import React from "react";
import Seo from "@/components/Seo";

export default function Impressum() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 prose-sm">
      <Seo title="Impressum – HELIUM Catering UG" description="Impressum und Anbieterkennzeichnung der HELIUM Catering UG." />
      <h1 className="text-3xl font-extrabold font-display">Impressum</h1>
      <div className="mt-6 space-y-4 text-gray-700 text-sm leading-relaxed">
        <div><strong>Angaben gemäß § 5 TMG</strong><br />HELIUM Catering UG (haftungsbeschränkt)<br />Deutschland</div>
        <div><strong>Vertreten durch</strong><br />Ayman Schurrab (Geschäftsführer)</div>
        <div><strong>Registereintrag</strong><br />Handelsregister: HRB 13252</div>
        <div><strong>Kontakt</strong><br />E-Mail: info@helium-catering.de</div>
        <div><strong>Umsatzsteuer-ID</strong><br />USt-IdNr. gemäß § 27 a UStG: DE369898724</div>
        <div><strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</strong><br />Ayman Schurrab, Anschrift wie oben</div>
      </div>
    </div>
  );
}
